import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Toggle from '../../../components/common/toggleButton';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import InputField from '../../../components/common/input-field';

export interface ImageBorderProps {
  value: ImageBorderValueProps;
  onChange: (_value: ImageBorderValueProps) => void;
  title: string;
}

export const imageBorderProps = {
  imageBorder: {
    deviceType: 'desktop',
    borderBottomLeft: {
      desktop: '0',
      tablet: '0',
      mobile: '0',
    },
    borderBottomRight: {
      desktop: '0',
      tablet: '0',
      mobile: '0',
    },
    borderTopLeft: {
      desktop: '0',
      tablet: '0',
      mobile: '0',
    },
    borderTopRight: {
      desktop: '0',
      tablet: '0',
      mobile: '0',
    },
  },
};

export interface ImageBorderValueProps {
  borderTopLeft: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  borderTopRight: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  borderBottomLeft: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  borderBottomRight: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  deviceType: string;
}

const ImageBorder: React.FC<ImageBorderProps> = ({
  title,
  value,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      <div
        className={`overflow-hidden rounded w-full ${isOpen ? 'max-h-screen' : 'max-h-0'}`}>
        <div className="border border-gray-300 p-2 grid gap-4">
          <Toggle<ImageBorderValueProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <FieldLabel
            label={
              (
                <CustomTooltip title="Border Radius">
                  <span>Border Radius</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <div className="grid grid-cols-[1fr_1fr] gap-2 border-t-1">
              <InputField
                label="Top-Left"
                value={value?.borderTopLeft?.[value?.deviceType]}
                className="h-[42px]"
                onChange={e => {
                  const newValue = e.replace(/[^0-9%]/g, '');
                  onChange({
                    ...value,
                    borderTopLeft: {
                      ...value?.borderTopLeft,
                      [value?.deviceType]: newValue,
                    },
                  });
                }}
              />
              <InputField
                className="h-[42px]"
                value={value?.borderTopRight?.[value?.deviceType]}
                onChange={e => {
                  const newValue = e.replace(/[^0-9%]/g, '');
                  onChange({
                    ...value,
                    borderTopRight: {
                      ...value?.borderTopRight,
                      [value?.deviceType]: newValue,
                    },
                  });
                }}
                label="Top-Right"
              />
              <InputField
                className="h-[42px]"
                value={value?.borderBottomLeft?.[value?.deviceType]}
                onChange={e => {
                  const newValue = e.replace(/[^0-9%]/g, '');
                  onChange({
                    ...value,
                    borderBottomLeft: {
                      ...value?.borderBottomLeft,
                      [value?.deviceType]: newValue,
                    },
                  });
                }}
                label="Bottom-Left"
              />
              <InputField
                className="h-[42px]"
                value={value?.borderBottomRight?.[value?.deviceType]}
                onChange={e => {
                  const newValue = e.replace(/[^0-9%]/g, '');
                  onChange({
                    ...value,
                    borderBottomRight: {
                      ...value?.borderBottomRight,
                      [value?.deviceType]: newValue,
                    },
                  });
                }}
                label="Bottom-Right"
              />
            </div>
          </FieldLabel>
        </div>
      </div>
    </>
  );
};

export default ImageBorder;
